import { PostEditorPostError, PostEditorPostErrors, PostGroupsType } from '../../../models/post-editor';
import { ErrorMessageSeverity } from '../../../constants/form';
import { PostEditorValidationMessages } from '../constants/validation-messages';
import { severityResolver } from './helpers/severity-resolver';
import { SingularValidator } from './helpers/singular-validator';

export const checkLinkPreviewSuppressed = (
  postGroup: PostGroupsType,
  severity: ErrorMessageSeverity
): PostEditorPostErrors => {
  const { customizeContentPerProfile, profiles } = postGroup;
  let results: PostEditorPostError[] = [];
  if (customizeContentPerProfile) {
    postGroup.posts.forEach(post => {
      const { texts, link } = post.content;
      const selectedSocialProfiles = profiles.filter(
        p =>
          (p.__typename === 'FacebookSocialProfile' || p.__typename === 'LinkedInSocialProfile') &&
          p.profileId === post.customizedProfileId
      );
      if (!selectedSocialProfiles.length || !link) return;
      const errors = texts.flatMap(text =>
        SingularValidator.checkLinkPreviewSuppressedInvalid(text, link.removePreview)
          ? {
              profileId: post.customizedProfileId,
              variationId: text.id,
              severity: severityResolver(post, severity),
              selectedSocialProfiles,
              message: PostEditorValidationMessages.checkLinkPreviewSuppressed
            }
          : []
      );
      results = [...results, ...errors];
    });
  } else {
    const { texts, link } = postGroup.groupPostAttributes.content;
    const selectedSocialProfiles = profiles.filter(
      p => p.__typename === 'FacebookSocialProfile' || p.__typename === 'LinkedInSocialProfile'
    );
    if (!selectedSocialProfiles.length || !link) return false;
    const errors = texts.flatMap(text =>
      SingularValidator.checkLinkPreviewSuppressedInvalid(text, link.removePreview)
        ? {
            profileId: null,
            variationId: text.id,
            severity: severityResolver(postGroup.groupPostAttributes, severity),
            selectedSocialProfiles,
            message: PostEditorValidationMessages.checkLinkPreviewSuppressed
          }
        : []
    );
    results = [...results, ...errors];
  }
  return results.length ? results : false;
};
